// extracted by mini-css-extract-plugin
module.exports = {"CloseIconDefault":"CloseIcon__CloseIconDefault___vLUFB","DisabledCloseIcon":"CloseIcon__DisabledCloseIcon___1WiUm"};